var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { requiredIndicatorStyle, requiredDotStyle } from './styles';
function RequiredIndicator(_a) {
    var isRequired = _a.isRequired, indicator = _a.indicator, inverted = _a.inverted, size = _a.size;
    function renderIndicator() {
        if (indicator === 'showOptional' && !isRequired) {
            return 'Optional';
        }
        else if (indicator === 'showRequired' && isRequired) {
            return (_jsxs(_Fragment, { children: [_jsx("span", { css: requiredDotStyle({ size: size, inverted: inverted }) }), "Required"] }));
        }
        return null;
    }
    return (_jsx(Text, __assign({ css: requiredIndicatorStyle({ inverted: inverted, size: size }), "aria-hidden": true }, { children: renderIndicator() })));
}
export default RequiredIndicator;
